"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  Speech: () => Speech
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneSpeech");
  return hybrid;
}
var latest = 0;
function start(options, onEvent) {
  if (typeof onEvent !== "function") {
    throw new TypeError("Speech.start: onEvent must be a function");
  }
  var session = ++latest;
  native().start(options, onEvent);
  return {
    stop: function stop() {
      if (session === latest) native().stop();
    },
    abort: function abort() {
      if (session === latest) native().abort();
    }
  };
}
var Speech = Object.freeze({
  isAvailable: function isAvailable() {
    return native().isAvailable();
  },
  getPermissions: function getPermissions() {
    return native().getPermissions().catch(import_nativeError.rethrowNativeError);
  },
  requestPermissions: function requestPermissions() {
    return native().requestPermissions().catch(import_nativeError.rethrowNativeError);
  },
  start
});
//# sourceMappingURL=index.native.js.map
